import { render, staticRenderFns } from "./bindDealerDialog.vue?vue&type=template&id=4f02a022&scoped=true"
import script from "./bindDealerDialog.vue?vue&type=script&lang=js"
export * from "./bindDealerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f02a022",
  null
  
)

export default component.exports